import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { STORE_NAMES } from './constants';

interface AuthState {
  accessToken: string | null;
  refreshToken?: string | null;
  setAccessToken: (token: string) => void;
  setRefreshToken: (token: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        accessToken: null,
        refreshToken: null,
        setRefreshToken: (token: string) => set({ refreshToken: token }, undefined, 'auth/setRefreshToken'),
        setAccessToken: (token: string) => set({ accessToken: token }, undefined, 'auth/setAccessToken'),
        clearAuth: () => set({ accessToken: null, refreshToken: null }, undefined, 'auth/clearAuth'),
      }),
      { name: STORE_NAMES.AUTH },
    ),
    {
      name: STORE_NAMES.AUTH,
      enabled: process.env.NODE_ENV === 'development',
    },
  ),
);
